import { render, staticRenderFns } from "./SwitchView.vue?vue&type=template&id=dee7b2a6&scoped=true&"
import script from "./SwitchView.vue?vue&type=script&lang=ts&"
export * from "./SwitchView.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchView.vue?vue&type=style&index=0&id=dee7b2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee7b2a6",
  null
  
)

export default component.exports